import { createReducer, on } from '@ngrx/store';
import { CreateNewIntegration } from '../actions/integration-management-create-new.actions';
import {
  CloseQcMessageAppEditIntegration,
  EditQcMessageAppIntegrationSystem,
  NotificationEmailChange,
  LookBackDaysChange,
  NameChange,
  PasswordChange,
  QcMessageAppSubmitData,
  SaveQcMessageAppConfigurationFailed,
  SaveQcMessageAppConfigurationSuccess,
  StatusChange,
  ToggleCampaignReportingHelpTextStatus,
  ToggleCredentialsConfHelpTextStatus,
  ToggleQcEndpointConfHelpTextStatus,
  UpdateQcMessageAppConfigurationSuccess,
  UsernameChange,
  NotificationEmailValidationStatus,
  LookBackDaysValidationStatus
} from '../actions/qc-message-app-configuration.actions';

export interface QcMessageAppConfigurationState {
  name: string;
  notificationEmail: string;
  isActive: boolean;
  username: string;
  password: string;
  showUpdateBtn: boolean;
  showCancelBtn: boolean;
  disableName: boolean;
  endpointConfigurationHelpTextStatus: boolean;
  credentialsConfigurationHelpTextStatus: boolean;
  campaignReportingHelpTextStatus: boolean;
  lookBackDays: number | null;
  isSubmittedData: boolean;
  notificationEmailShowErrorMessage: boolean;
  lookBackDaysShowErrorMessage: boolean;
}

const initialState: QcMessageAppConfigurationState = {
  name: '',
  notificationEmail: '',
  isActive: false,
  username: '',
  password: '',
  showUpdateBtn: false,
  showCancelBtn: false,
  disableName: false,
  lookBackDays: 15,
  endpointConfigurationHelpTextStatus: false,
  credentialsConfigurationHelpTextStatus: false,
  campaignReportingHelpTextStatus: false,
  isSubmittedData: false,
  notificationEmailShowErrorMessage: false,
  lookBackDaysShowErrorMessage: false
};

export const QcMessageAppConfigurationReducer = createReducer(
  initialState,
  on(NameChange, (state, { name }) => ({
    ...state,
    name
  })),
  on(NotificationEmailChange, (state, { notificationEmail }) => ({
    ...state,
    notificationEmail
  })),
  on(StatusChange, (state, { isActive }) => ({
    ...state,
    isActive
  })),
  on(UsernameChange, (state, { username }) => ({
    ...state,
    username
  })),
  on(PasswordChange, (state, { password }) => ({
    ...state,
    password
  })),
  on(LookBackDaysChange, (state, { lookBackDays }) => ({
    ...state,
    lookBackDays,
  })),
  on(CreateNewIntegration, () => ({
    ...initialState,
  })),
  on(CloseQcMessageAppEditIntegration, (state) => initialState),
  on(ToggleQcEndpointConfHelpTextStatus, (state) => ({
    ...state,
    endpointConfigurationHelpTextStatus: !state.endpointConfigurationHelpTextStatus,
  })),
  on(ToggleCredentialsConfHelpTextStatus, (state) => ({
    ...state,
    credentialsConfigurationHelpTextStatus: !state.credentialsConfigurationHelpTextStatus,
  })),
  on(ToggleCampaignReportingHelpTextStatus, (state) => ({
    ...state,
    campaignReportingHelpTextStatus: !state.campaignReportingHelpTextStatus,
  })),
  on(SaveQcMessageAppConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    name: res.payload.data.integrationConfig.integrationDisplayName,
    notificationEmail: res.payload.data.integrationConfig.executionNotificationReceiver,
    isActive: res.payload.data.deleted,
    username: res.payload.data.endpointConfiguration.credentialConfig.username,
    password: res.payload.data.endpointConfiguration.credentialConfig.password,
    lookBackDays: res.payload.data.integrationConfig.daysLookBack,
    rootConfigurationHelpTextStatus: false,
    credentialsConfigurationHelpTextStatus: false,
    campaignReportingHelpTextStatus: false,
    isSubmittedData: false,
  })),
  on(SaveQcMessageAppConfigurationFailed, (state) => ({
    ...state,
    showUpdateBtn: false,
    disableName: false,
  })),
  on(EditQcMessageAppIntegrationSystem, (state, { qcMessageAppData }) => ({
    ...state,
    name: qcMessageAppData.integrationConfig.integrationDisplayName,
    notificationEmail: qcMessageAppData.integrationConfig.executionNotificationReceiver,
    isActive: qcMessageAppData.deleted,
    username: qcMessageAppData.endpointConfiguration.credentialConfig.username,
    password: qcMessageAppData.endpointConfiguration.credentialConfig.password,
    lookBackDays: qcMessageAppData.integrationConfig.daysLookBack,
    showUpdateBtn: true,
    disableName: true,
    showCancelBtn: true,
    isSubmittedData: false,
  })),
  on(CreateNewIntegration, (state) => ({
    ...state,
    name: '',
    notificationEmail: '',
    isActive: false,
    username: '',
    password: '',
    showUpdateBtn: false,
    disableName: false,
    endpointConfigurationHelpTextStatus: false,
    credentialsConfigurationHelpTextStatus: false,
    campaignReportingHelpTextStatus: false,
    showCancelBtn: false,
    isSubmittedData: false,
  })),
  on(UpdateQcMessageAppConfigurationSuccess, (state, { res }) => ({
    ...state,
    name: res.payload.data.integrationConfig.integrationDisplayName,
    notificationEmail: res.payload.data.integrationConfig.executionNotificationReceiver,
    isActive: res.payload.data.deleted,
    username: res.payload.data.endpointConfiguration.credentialConfig.username,
    password: res.payload.data.endpointConfiguration.credentialConfig.password,
    lookBackDays: res.payload.data.integrationConfig.daysLookBack,
    rootConfigurationHelpTextStatus: false,
    showUpdateBtn: true,
    disableName: true,
  })),
  on(QcMessageAppSubmitData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(NotificationEmailValidationStatus, (state, {isInvalid}) => ({
    ...state,
    notificationEmailShowErrorMessage: isInvalid
  })),
  on(LookBackDaysValidationStatus, (state, {isInvalid}) => ({
    ...state,
    lookBackDaysShowErrorMessage: isInvalid
  }))
);
